module.exports = __webpack_public_path__ + "static/media/pay2.50899671.png";